export default "__VITE_ASSET__DlK5bp5B__"